<template>
	<div>
		<el-carousel :height="bannerHeight+'px'">
			<el-carousel-item v-for="(item, index) in sliders" :key="index">
				<img style="width:100%;height: inherit;" :src="item.img" class="slider_img"
					@click="getOpenMinChengXuLink">
			</el-carousel-item>
		</el-carousel>
		<div id="寄存回收" class="solve head-label">
			<div style="text-align: center;" class="font_size_24">
				寄存回收流程
			</div>
		</div>
		<!-- 盒子 -->
		<div class="border_parent">
			<el-row :gutter="10">
				<el-col :xs="12" :sm="12" :md="6">
					<div class="border" @click="getOpenMinChengXuLink">
						<div class="border_img_parent">
							<img :src="images[1].img" class="img_border" />
						</div>
						<div class="border_title">{{images[1].title}}</div>
						<div class="border_content_one">{{images[1].content[0]}}</div>
						<div class="border_content_two">{{images[1].content[1]}}</div>
					</div>
				</el-col>
				<el-col :xs="12" :sm="12" :md="6">
					<div class="border" @click="getOpenMinChengXuLink">
						<div class="border_img_parent">
							<img :src="images[2].img" class="img_border" />
						</div>
						<div class="border_title">{{images[2].title}}</div>
						<div class="border_content_one">{{images[2].content[0]}}</div>
						<div class="border_content_two">{{images[2].content[1]}}</div>
					</div>
				</el-col>
				<el-col :xs="12" :sm="12" :md="6">
					<div class="border" @click="getOpenMinChengXuLink">
						<div class="border_img_parent">
							<img :src="images[3].img" class="img_border" />
						</div>
						<div class="border_title">{{images[3].title}}</div>
						<div class="border_content_one">{{images[3].content[0]}}</div>
						<div class="border_content_two">{{images[3].content[1]}}</div>
					</div>
				</el-col>
				<el-col :xs="12" :sm="12" :md="6">
					<div class="border" style="margin-right: 0" @click="getOpenMinChengXuLink">
						<div class="border_img_parent">
							<img :src="images[4].img" class="img_border" />
						</div>
						<div class="border_title">{{images[4].title}}</div>
						<div class="border_content_one">{{images[4].content[0]}}</div>
						<div class="border_content_two">{{images[4].content[1]}}</div>
					</div>
				</el-col>
			</el-row>
		</div>
		<!-- 手机端商品展示 -->

		<!-- 延期买回-->
		<div id="延期买回" class="product_spec_title head-label">
			<div style="text-align: center;" class="font_size_24">
				延期买回流程
			</div>
		</div>
		<div class="product_spec_parent">
			<div class="border_one border_spec" @click="getOpenMinChengXuLink">
				<div class="border_spec_inner_one">
					<img :src="spec.product[0].img" style="width: 50px;height: 50px" />
					<div style="margin-left:5px; font-weight: bold;" class="font_size_24">
						{{spec.product[0].title}}
					</div>
				</div>
				<div style="display: flex;flex-direction: column;">
					<div class="border_spec_content_one">
						{{spec.product[0].contents[0]}}
					</div>
					<div class="border_spec_inner_last">
						{{spec.product[0].contents[1]}}
					</div>
				</div>
			</div>
			<div>
				<img :src="computeArrowImg" class="border_spec_img" />
			</div>
			<div class="border_spec" @click="getOpenMinChengXuLink">
				<div class="border_spec_inner_one">
					<img :src="spec.product[1].img" style="width: 50px;height: 50px" />
					<div style="margin-left:5px; font-weight: bold;" class="font_size_24">
						{{spec.product[1].title}}
					</div>
				</div>
				<div style="display: flex;flex-direction: column;">
					<div class="border_spec_content_one">
						{{spec.product[1].contents[0]}}
					</div>
					<div class="border_spec_inner_last">
						{{spec.product[1].contents[1]}}
					</div>
				</div>
			</div>
			<div>
				<img :src="computeArrowImg" class="border_spec_img" />
			</div>
			<div class="border_spec" @click="getOpenMinChengXuLink">
				<div class="border_spec_inner_one">
					<img :src="spec.product[2].img" style="width: 50px;height: 50px" />
					<div style="margin-left:5px; font-weight: bold;" class="font_size_24">
						{{spec.product[2].title}}
					</div>
				</div>
				<div style="display: flex;flex-direction: column;">
					<div class="border_spec_content_one">
						{{spec.product[2].contents[0]}}
					</div>
					<div class="border_spec_inner_last">
						{{spec.product[2].contents[1]}}
					</div>
				</div>
			</div>
			<div>
				<img :src="computeArrowImg" class="border_spec_img" />
			</div>
			<div class="border_spec" style="margin-right: 0" @click="getOpenMinChengXuLink">
				<div class="border_spec_inner_one">
					<img :src="spec.product[3].img" style="width: 50px;height: 50px" />
					<div style="margin-left:5px; font-weight: bold;" class="font_size_24">
						{{spec.product[3].title}}
					</div>
				</div>
				<div style="display: flex;flex-direction: column;">
					<div class="border_spec_content_one">
						{{spec.product[3].contents[0]}}
					</div>
					<div class="border_spec_inner_last">
						{{spec.product[3].contents[1]}}
					</div>
				</div>
			</div>
		</div>
		<!-- 关于我们-->
		<div id="关于我们" class="about_me head-label">
			<div style="text-align: center;" class="font_size_24">
				关于我们
			</div>
		</div>
		<div style="width: 90%;background-color: #F2F6FC;margin: 10px auto;">
			<div style="display: flex; flex-direction: column;width: 100%;">
				<p class="about_me_p">{{company[0]}}</p>
				<p class="about_me_p">{{company[1]}}</p>
				<p class="about_me_p">{{company[2]}}</p>
				<p class="about_me_p">{{company[3]}}</p>
				<p class="about_me_p">{{company[4]}}</p>
				<p class="about_me_p">{{company[5]}}</p>
			</div>
		</div>

	</div>
</template>
<script>
	import {
		encryptLong,
		syShopSign
	} from '@/utils/rsaEncrypt'
	export default {
		name: 'Index',
		data() {
			return {
				// 容器的高度
				bannerHeight: 0,
				// 浏览器宽度
				screeWith: 0,
				sliders: [],
				images: [{
						img: require('../../static/other/店铺管理.png'),
						title: "提交申请",
						content: ["在线提交资料", "一对一匹配客服"]
					},
					{
						img: require('../../static/other/店铺管理.png'),
						title: "提交申请",
						content: ["在线提交资料", "一对一匹配客服"]
					},
					{
						img: require('../../static/other/数据分析.png'),
						title: "查询报价",
						content: ["系统自动检测估价", "专业检测师免费评估"]
					}, {
						img: require('../../static/other/用户构建.png'),
						title: "当面评估",
						content: ["全程免费为您服务", "允许可免费上门服务"]
					},
					{
						img: require('../../static/other/品牌渠道.png'),
						title: "快速寄存",
						content: ["专柜封存", "简单 方便 快捷 安全"]
					}
				],
				spec: {
					img: require('../../static/other/arrow.png'),
					product: [{
							img: require('../../static/other/手指.png'),
							title: "一键操作",
							contents: ["一键延期或买回", "操作方便快捷安全"]
						},
						{
							img: require('../../static/other/店铺管理.png'),
							title: "一键延期",
							contents: ["系统实时监控寄存状态", "自动检测延期金额和差价"]
						},
						{
							img: require('../../static/other/用户构建.png'),
							title: "一键买回",
							contents: ["校验买回码", "支付买回费用"]
						},
						{
							img: require('../../static/other/助力零售.png'),
							title: "平台核查",
							contents: ["检测师核对买回信息", "顺丰发货业务灵活方便"]
						}
					]
				},
				company: [
					"云当铺”诚信为本,厚德载物”。实时提供手机、平板、相机、笔记本、首饰、包包、奢侈品等便捷、安全寄存回收信息服务平台！",
					"[线上线下]线下专人上门办理、线下全国包邮办理。",
					"[高价回收]专业检测师验机全，回收价格高于其它网站。",
					"[可选备机]针对仅有一台手机寄存者可提供智能产品备用。",
					"[快速买回]用户提交买回时，专业客服第一时间办理。",
					"[全民优惠]无论新用户或老用户都有优惠，可并存。订单自动计算。",
				],
				// carousel_height: '550px',
			}
		},
		methods: {
			getOpenMinChengXuLink() {
				if (this.isMobile()) {
					let url = '/sy/aboutUs/getScheme';
					const timeStamp = new Date().getTime();
					const sySign = syShopSign();
					const nonce = Math.floor(1000000 + Math.random() * 9000000);// 7位随机数
					const CheckCsrf = encryptLong(sySign + timeStamp + nonce);
					this.axios.get(url, {
						headers: {
							'TimeStamp': timeStamp,
							'CheckCsrf': CheckCsrf,
							'nonce':nonce,
							'Content-Type': 'application/x-www-form-urlencoded'
						}
					}).then(res => {
						location.href = res.data.data;
					})
				} else {
					console.log('pc端不跳转')
					return;
				}

			},
			// 判断是否是手机端，如果是，返回true
			isMobile() {
				let flag = navigator.userAgent.match(
					/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
				)
				return flag
			}
		},
		mounted() {
			this.sliders = [{
						img: require("../../static/slider/a2.jpg")
					},
					{
						img: require('../../static/slider/a3.jpg')
					}
				],
				// 首次加載時，初始化高度
				this.screeWith = window.innerWidth
			this.bannerHeight = 550 / 1920 * this.screeWith

			if (this.isMobile()) {
				this.bannerHeight = 200
			} else {
				// 窗口大小發生變化
				window.onresize = () => {
					this.screeWith = window.innerWidth
					this.bannerHeight = 550 / 1920 * this.screeWith
				}
			}
		},
		computed: {
			//计算高度
			// computeHeight() {
			//     let screenHeight = document.body.clientWidth;
			//     if (screenHeight > 415) {
			//         return '550px';
			//     } else {
			//         return '250px';
			//     }
			// },
			computeArrowImg() {
				let screenHeight = document.body.clientWidth;
				if (screenHeight > 450) {
					return require('../../static/other/arrow.png');
				} else {
					return require('../../static/other/arrow_down.png');
				}
			}

		},
	}
</script>

<style lang="less" scoped>
	/* 清除banner滾動條 */
	.el-carousel--horizontal {
		overflow-x: hidden;
		overflow-y: hidden;
	}

	.el-carousel__indicator.is-active {
		border-bottom: 2px solid #ff717b !important;
	}

	.border_parent {
		width: 90%;
		margin: auto;
	}

	.slider_img {
		height: 550px;
		width: 100%;
	}

	.solve {
		margin-top: 30px;
		margin-bottom: 10px
	}

	.border {
		border-radius: 6px;
		border: 1px solid #EBEEF5;
		height: auto;
		margin: 10px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
	}

	.border_one {
		margin-left: 0;
	}

	.border_img_parent {
		margin-top: 20px;
		display: flex;
		justify-content: center;
	}

	.product_mobile_content {
		height: 300px;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
	}

	.product_mobile_img {
		width: 50%;
	}

	.product_mobile_title {
		font-weight: bold;
		text-align: center;
	}

	.product_pc_one {
		text-align: center;
		min-height: 400px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.font_size_30 {
		font-size: 1.875rem;
	}

	.product_font_style {
		font-size: 1.125rem;
	}

	.product_pc_img {
		width: 100%
	}

	.product_pc_img_div {
		width: 50%;
		float: left;
		display: flex;
		align-items: center;
	}

	.product_pc {
		display: flex;
		width: 90%;
		margin: 20px auto;
		background: #F2F6FC;
		align-items: center;
	}

	.product_spec_title {
		margin-top: 30px;
		margin-bottom: 10px
	}

	.product_spec_parent {
		display: flex;
		width: 90%;
		margin: 20px auto;
		align-items: center;
		height: auto
	}

	.cooperation_parent {
		display: flex;
		justify-content: center;
		width: 90%;
		margin: 20px auto;
		align-items: center;
		height: auto
	}

	.border_spec {
		border-radius: 6px;
		border: 1px solid #EBEEF5;
		float: left;
		width: 25%;
		height: auto;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	}

	.about_me_p {
		font-size: 1.25rem;
		font-weight: normal;
		padding: 0 20px;
		margin: 10px;
	}

	.border_title {
		font-family: "PingFang SC";
		margin-top: 10px;
		font-size: 1.125rem;
		font-weight: bold;
		text-align: center;
	}

	.border_content_one {
		margin-top: 20px;
		font-size: 1.125rem;
		text-align: center;
	}

	.border_content_two {
		margin-top: 5px;
		font-size: 1.125rem;
		margin-bottom: 25px;
		text-align: center;
	}

	.img_border {
		margin-top: 15px;
		width: 80px;
		height: 80px
	}

	.border_spec_inner_one {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 35px;
		height: 70px;
	}

	.border_spec_content_one {
		margin-top: 15px;
		font-size: 1.125rem;
		float: left;
		text-align: center;
	}

	.border_spec_inner_last {
		margin-top: 15px;
		font-size: 1.125rem;
		float: left;
		margin-bottom: 25px;
		text-align: center;
	}

	.cooperation {
		margin-top: 30px;
		width: 100%;
	}

	.about_me {
		display: flex;
		margin-top: 30px;
		justify-content: center;
		width: 100%;
	}

	.product_mobile {
		width: 90%;
		align-items: center;
		margin: 20px auto;
		background: #F2F6FC;
	}

	.product_mobile_img_div {
		width: 50%;
		height: auto;
	}

	.product_mobile_content_one {
		margin-top: 20px;
		text-align: center;
	}

	.product_mobile_content_two {
		margin-top: 10px;
		text-align: center;
	}

	/* 屏幕设备适配 max-device-width: 400px */
	@media screen and (max-device-width: 415px) {
		.slider_img {
			height: 250px;
			width: 100%;
		}


		.border_parent {
			display: flex;
			width: 90%;
			margin: auto;
			height: auto;
			flex-direction: column;
		}

		.border {
			border-radius: 6px;
			border: 1px solid #EBEEF5;
			float: left;
			width: 100%;
			height: auto;
			margin: 10px 0 auto;
			box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
				/*background: aquamarine;*/
		}

		.border_img_parent {
			margin-top: 0;

		}

		.product_mobile {
			width: 90%;
			align-items: center;
			margin: 20px auto;
			height: auto;
			background: #F2F6FC;
		}

		.product_mobile_content {
			width: 100%;
			margin-top: 15px;
		}

		.product_mobile_content_one {
			margin-top: 5px;
		}

		.product_mobile_content_two {
			margin-top: 5px;
		}

		.product_mobile_img_div {
			display: flex;
			width: 100%;
			height: auto;
			justify-content: center;
			margin-top: 10px;
			margin-bottom: 15px;
		}

		.product_mobile_img {
			float: left;
		}

		.product_mobile_title {
			font-weight: bold;
		}

		.product_pc_one {
			width: 100%;
			margin-top: 15px;
		}

		.font_size_30 {
			font-size: 1.25rem;
		}

		.product_font_style {
			font-size: 1rem;
		}

		.product_pc_img {
			height: 280px;
			width: 320px;
		}

		.product_pc_img_div {
			width: 100%;
			float: left;
			display: flex;
			align-items: center;
			justify-content: center;
			margin-bottom: 15px;
		}

		.product_pc {
			display: flex;
			width: 90%;
			height: auto;
			margin: 20px auto;
			background: #F2F6FC;
			flex-direction: column;
		}

		.head-label {
			display: flex;
			margin-top: 20px;
			justify-content: center;
		}

		.product_spec_parent {
			display: flex;
			width: 90%;
			align-items: center;
			justify-content: center;
			margin: 20px auto;
			height: auto;
			flex-direction: column;
		}

		.border_spec {
			float: left;
			height: auto;
			margin: 8px;
			width: 100%;
			border-radius: 6px;
			border: 1px solid #EBEEF5;
			box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		}


		.border_title {
			font-family: "PingFang SC";
			margin-top: 5px;
			font-size: 1rem;
			font-weight: bold;
		}

		.border_content_one {
			margin-top: 5px;
			font-size: 1rem;
		}

		.border_content_two {
			margin-top: 5px;
			font-size: 1rem;
			margin-bottom: 8px;
		}

		.font_size_24 {
			font-size: 1.25rem !important;
			font-weight: normal !important;
		}

		.about_me_p {
			font-size: 1rem !important;
		}

		.img_border {
			margin-top: 8px;
			width: 60px;
			height: 60px
		}

		.border_spec_inner_one {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 8px;
			/*background-color: aqua;*/
			height: 70px;
		}

		.border_spec_content_one {
			margin-top: 5px;
			font-size: 1.125rem;
			float: left;
		}

		.border_spec_inner_last {
			/*background-color: bisque;*/
			margin-top: 5px;
			font-size: 1.125rem;
			float: left;
			margin-bottom: 8px;
		}

		.about_me {
			display: flex;
			margin-top: 10px;
			width: 100%;
		}
	}

	.border_spec_img {
		width: 75px;
		height: 55px;
		align-self: center
	}

	.font_size_24 {
		font-size: 1.5rem;
	}
</style>


// WEBPACK FOOTER //
// src/components/Index.vue